import getRemBase from 'propel/getRemBase';

const setHeaderHeight = () => {
	const header = document.querySelector('.main-header');
	const adminBar = document.getElementById('wpadminbar');

	const headerHeight = header ? header.offsetHeight : 0;
	const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;

	document.body.style.setProperty(
		'--header-height',
		`${(headerHeight + adminBarHeight) / getRemBase()}rem`
	);

	// Set default alert-height to 0px (alert-top block will overwrite if present).
	if (!document.body.style.getPropertyValue('--alert-height')) {
		document.body.style.setProperty('--alert-height', '0px');
	}
};

export default setHeaderHeight;
